var map = {
	"./1-theme.png": 1851,
	"./1.png": 7262,
	"./2-theme.png": 4141,
	"./2.png": 5784,
	"./3-theme.png": 2886,
	"./3.png": 5286,
	"./4-theme.png": 4307,
	"./4.png": 7977,
	"./5-theme.png": 8513,
	"./5.png": 7823,
	"./6-theme.png": 1139,
	"./6.png": 9013,
	"./7-theme.png": 7922,
	"./7.png": 7832,
	"./8-theme.png": 9807,
	"./8.png": 2245,
	"./Contact.jpg": 8945,
	"./Moonstone.webp": 5061,
	"./qr.jpg": 4808,
	"./we-chat.png": 6088
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9158;